import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
export const WeeklyHeader = () => {
    const { t } = useTranslation('Datepicker');
    const theme = useTheme('Datepicker').WeeklyHeaderStyles;
    return (React.createElement("div", { className: theme.week }, [...Array(7)].map((_, index) => (React.createElement("div", { key: index, className: cn(theme.day, theme.dayOfWeekName) },
        React.createElement("span", null, t(`week_short_${index}`)))))));
};
